var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderListSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2663",
    "data-name": "Group 2663",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 13.249,
    viewBox: "0 0 18 13.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1786",
    "data-name": "Rectangle 1786",
    width: 18,
    height: 13.249,
    transform: "translate(0 0)",
    fill: "#610D24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2662",
    "data-name": "Group 2662",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M39.024,2.518H26.068a.943.943,0,1,1,0-1.886H39.024a.943.943,0,1,1,0,1.886",
    transform: "translate(-21.967 -0.553)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M39.024,47.185H26.068a.943.943,0,1,1,0-1.886H39.024a.943.943,0,1,1,0,1.886",
    transform: "translate(-21.967 -39.605)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M39.024,92.124H26.068a.943.943,0,1,1,0-1.886H39.024a.943.943,0,0,1,0,1.886",
    transform: "translate(-21.967 -78.895)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M.565.963a.963.963,0,1,1,.963.963A.963.963,0,0,1,.565.963",
    transform: "translate(-0.494 0)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M0,45.387a.963.963,0,1,1,.963.963A.963.963,0,0,1,0,45.387",
    transform: "translate(0 -38.84)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M.565,91.041A.963.963,0,1,1,1.528,92a.963.963,0,0,1-.963-.963",
    transform: "translate(-0.494 -78.755)",
    fill: "#610D24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderListSelected);
export default __webpack_public_path__ + "static/media/order_list_selected.080a640ae3df2e43835c440fd554c86d.svg";
export { ForwardRef as ReactComponent };